import axios from 'axios';
import { getInstance } from './msal-instance';

const apiClient = axios.create();

export const setApiBaseUrl = (url: string) => {
  if (url) {
    apiClient.defaults.baseURL = url;
    console.log(`Axios baseURL set to: ${url}`);
  } else {
    console.error("Attempted to set an empty or invalid baseURL for Axios.");
  }
};

apiClient.interceptors.request.use(
  async (config) => {
    const msalInstance = await getInstance();
    const account = msalInstance?.getAllAccounts()[0];

    console.log('Axios Interceptor: Attempting to add token...');
    if (config.method?.toUpperCase() === 'OPTIONS') {
      return config;
    }

    if (account.idToken) {
      config.headers.Authorization = `Bearer ${account.idToken}`;
      console.log('Axios Interceptor: Token added to Authorization header.');
    } else {
      console.warn('Axios Interceptor: idToken returned null/undefined unexpectedly.');
    }

    return config;
  },
  (error) => {
    console.error('Axios request config error:', error);
    return Promise.reject(error);
  },
);

export default apiClient;
